import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { CertificateModel, UploadModel, PdfPreviewModel, UploadModelFromAdmin, CertificateModelForAttachment } from '../variables/customer';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PdfService {
  baseUrl: string;

  constructor(private http: HttpClient,
    private commonService: CommonService) {
    this.baseUrl = environment.API_URL;
  }
  prefillPdf(certificate: CertificateModelForAttachment) {
    //return this.http.post(this.baseUrl + 'api/pdf', certificate, { responseType: 'arraybuffer' });
    // return this.http.post(this.baseUrl + 'api/pdf', certificate);

    const formData = new FormData();

  formData.append('templateName', certificate.templateName);
  formData.append('dateSubmitted', certificate.dateSubmitted.toISOString());
  formData.append('formId', certificate.formId.toString());
  formData.append('data', JSON.stringify(certificate.data));

  if (certificate.attachPDF) {
    formData.append('attachPDF', certificate.attachPDF);
  }

  return this.http.post(
    this.baseUrl + 'api/pdf',
    formData
  );
  }

  prefillPdfTemp(certificate: CertificateModel) {
    //return this.http.post(this.baseUrl + 'api/pdf', certificate, { responseType: 'arraybuffer' });
    return this.http.post(this.baseUrl + 'api/pdf/temp', certificate);
  }

  getHtml(formName: string, stateName: string, isEsign?: boolean,formType?:string) {
    if (isEsign) {
      return this.http.get(this.baseUrl + 'api/pdf/html/' + formName + "/" + stateName + "/true"+ (!formType ? "" : "?formType=" + formType));
    }
    else {
      return this.http.get(this.baseUrl + 'api/pdf/html/' + formName + "/" + stateName+ (!formType ? "" : "?formType=" + formType));
    }
  }

  afterUploadPdf(obj: UploadModel) {
    return this.http.post(this.baseUrl + 'api/pdf/upload', obj);

  }

  approveFillIn(referenceNumber: any) {
    return this.http.post(this.baseUrl + 'api/form/approve-fill-in/'+referenceNumber, {});
  }

  uploadPdfFile(fileName: string, obj: FormData) {
    return this.http.post(this.baseUrl + 'api/pdf/upload/' + fileName, obj);

  }

  getPdf(fileName: string) {
    return this.http.get(this.baseUrl + 'api/pdf/' + fileName);
  }

  getPdfMaster(fileName: string) {
    return this.http.get(this.baseUrl + 'api/pdf/get-presigned-url/' + fileName + '/' + localStorage.getItem('company_code'));
  }

  getHTMLRules(formName: string, stateName: string,formType?:string) {
    return this.http.get(this.baseUrl + 'api/pdf/htmlrules/' + formName + "/" + stateName+"?formType="+formType);
  }

  getPdfPreview(formName: string, customerId: number) {
    let obj: PdfPreviewModel = {
      formName: formName,
      customerId: customerId
    }
    return this.http.post(this.baseUrl + 'api/pdf/pdfpreview', obj);
  }

  uploadPdfFileFromAdmin(fileName: string, payorAccountNumber : string, companyCode: string, obj: FormData) {
    return this.http.post(this.baseUrl + 'api/pdf/upload-from-company-admin/' + fileName+'?payerAccountNumber='+payorAccountNumber+'&companyCode='+companyCode, obj);
  }

  afterUploadPdfFromAdmin(obj: UploadModelFromAdmin) {
    return this.http.post(this.baseUrl + 'api/pdf/upload-from-company-admin', obj);

  }

  ispdfpasswordprotected(obj: FormData)
  {
    return this.http.post(this.baseUrl + 'api/pdf/is-pdf-password-protected', obj);
  }
}

